export default __webpack_public_path__ + "static/techguru-example7-ebc39af758e16ca09d3489b1ca38537b.jpg";